/*
 * Name: Form Thanks
 * Desc:
 *
 */
import React from "react"
import ThankYou from "../../static/ThankYou/ThankYou"
import * as styles from "./FormThanks.module.scss"

const { NEXT_PUBLIC_ENV } = process.env

const FormThanks = () => (
  <div>
    <ThankYou
      className={styles.FormThanks}
      title="Thanks for signing up!"
      text="We will contact you shortly by email once we have finished reviewing your submission"
    />
  </div>
)

export default FormThanks
